import { render, staticRenderFns } from "./SPRSimpleAutocompleteDropdown.vue?vue&type=template&id=4fd0dbce&scoped=true"
import script from "./SPRSimpleAutocompleteDropdown.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleAutocompleteDropdown.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleAutocompleteDropdown.vue?vue&type=style&index=0&id=4fd0dbce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd0dbce",
  null
  
)

export default component.exports